/**
 * Add new parameter to query search query and get new query
 * @param {string} query
 * @param {string} key
 * @param {string} value
 * @return {string}
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:linkedregistrations-ui":true});}catch(e){}}();const composeQuery = (query: string, key: string, value: string): string => {
  return query.concat(`${query ? '&' : '?'}${key}=`, value);
};

export default composeQuery;
